<script lang="ts">
  import EventForm from '../components/EventForm.svelte';
</script>

<EventForm />
